import * as React from 'react';
import { useClickAway } from 'react-use';
import { FacebookShare, LinkedinShare, TwitterShare, WhatsappShare, EmailShare, } from 'react-share-lite';
import styled from 'styled-components';
const ShareButtons = (props) => {
    const [showBox, setShowBox] = React.useState(false);
    const shareBoxRef = React.useRef(null);
    useClickAway(shareBoxRef, (e) => {
        e.preventDefault();
        setShowBox(false);
    });
    return (React.createElement("button", { className: "dropdown border-0 bg-transparent ", style: { position: 'unset' }, "data-bs-toggle": "tooltip", "data-bs-placement": "top", "data-bs-title": props.tooltip, onClick: () => {
            setShowBox(true);
        } },
        React.createElement("img", { className: "d-inline", src: "/SiteFiles/images/program/shear.svg", style: { width: '20px', height: '20px' }, alt: "share" }),
        showBox && (React.createElement(ShareWrapper, { ref: shareBoxRef },
            React.createElement(FacebookShare, { url: props.url, title: props.title, round: true, size: 32 }),
            React.createElement(LinkedinShare, { url: props.url, title: props.title, round: true, size: 32 }),
            React.createElement(TwitterShare, { url: props.url, title: props.title, round: true, size: 32 }),
            React.createElement(WhatsappShare, { url: props.url, title: props.title, separator: ":: ", round: true, size: 32 }),
            React.createElement(EmailShare, { url: props.url, subject: props.title, body: props.title, round: true, size: 32 })))));
};
export default ShareButtons;
const ShareWrapper = styled.div `
  background-color: var(--IB-700);
  position: absolute;
  z-index: 1;
  border-radius: 5px;

  button {
    margin: 5px;
  }
`;
